import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-team-teaminsights',
  templateUrl: './team-teaminsights.component.html',
  styleUrls: ['./team-teaminsights.component.scss'],
  standalone: true,
  imports: [RouterLink, CommonModule],
})
export class TeamInsightsComponent {
  constructor(private appService: AppService) {}

  teamHasType() {
    return this.appService.getTeamInfo().teamMbtiType ? true : false;
  }
}
